import { SWRFetcher } from '@commenda/utils';
import { Country } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';
import { BASE_URL } from './types';

export function useMarketplaceServiceCountByCountry(): {
  data?: {
    servicesCountByCountry: { [key in Country]: number };
  };
  error?: unknown;
  mutate: KeyedMutator<any>;
} {
  const queryParams = new URLSearchParams();

  const { data, error, mutate } = useSWR<{
    servicesCountByCountry: { [key in Country]: number };
  }>(
    `${BASE_URL}/services/count-by-country?${queryParams.toString()}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data: data, error, mutate };
}
